import { MenuOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageSwitch } from './LanguageSwitch';

export const PublicDemoHeader = () => {
  const { t } = useTranslation();
  const [menuVisible, setMenuVisible] = useState<boolean>(false);

  const menu = () => {
    return (
      <>
        <a className="text-lg menu-item" href="https://ixordocs.webflow.io/document-processing">
          {t('public.header.ixordocs-ocr')}
        </a>
        <a className="text-lg menu-item" href="https://ixordocs.webflow.io/uitgaande-documenten">
          {t('public.header.peppol-doccle')}
        </a>
        <a className="text-lg menu-item" href="https://ixordocs.webflow.io/referenties">
          {t('public.header.references')}
        </a>
        <a className="text-lg menu-item" href="https://ixordocs.webflow.io/contact">
          {t('public.header.contact')}
        </a>
        <LanguageSwitch />
      </>
    );
  };

  return (
    <>
      <div
        className="bg-white w-full py-2.5 md:py-5 z-10 sticky top-0"
        style={{ boxShadow: '1px 0 20px -10px rgb(0 0 0 / 25%)' }}>
        <div className="flex justify-between items-center pl-8 pr-8 mx-auto" style={{ maxWidth: '1170px' }}>
          <a href="https://ixordocs.webflow.io/">
            <img src={require('../../images/logo.png')} alt="IxorDocs" className="w-12 md:w-20" />
          </a>
          <Button
            type="text"
            icon={<MenuOutlined style={{ color: '#0040b5', fontSize: '25px' }} />}
            onClick={() => {
              setMenuVisible((prev) => !prev);
            }}
            className="md:hidden"
          />
          <div className={`items-center hidden md:flex md:flex-row md:w-auto gap-7`}>{menu()}</div>
        </div>
      </div>
      <div
        style={{ top: 68, boxShadow: '1px 10px 20px -10px rgb(0 0 0 / 25%)' }}
        className={`w-full gap-6 box-border absolute bg-white z-10 flex flex-col overflow-hidden md:h-0 md:p-0 ${
          menuVisible ? 'h-auto p-5' : 'h-0 p-0'
        }`}>
        {menu()}
      </div>
    </>
  );
};
